<template>
  <v-container fluid fill-height pa-0 ma-0>
    <!--  <v-app-bar app elevation="0" color="transparent" clipped-right clipped-left>
      <v-spacer></v-spacer>

      <language></language>
    </v-app-bar> -->

    <!-- Sizes your content based upon application components -->
    <v-container style="height: 400px;">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />
        </v-col>
        <v-col cols="6" class="headline text-center">
          :( Su periodo de prueba o su suscripción anual ha finalizado
        </v-col>
        <v-col class="subtitle-1 text-center" cols="7">
          Para continuar usando PacReport es necesario contar con una
          suscripción anual. Puede adquirir una suscripción comunicándose a
          <b>soporte@pac.report</b> o llamando al <b>0963534703</b>
        </v-col>
        <v-col class="subtitle-1 text-center" cols="7">
          <v-btn color="secondary" @click="continuar">ENTENDIDO</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-content pa-0 ma-0>

      <v-container pa-0 ma-0>
       
        <v-layout align-center justify-center>
          <img src="@/assets/logo-white.svg" alt="avatar" width="240" />

          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            rounded
            height="6"
            color="primary"
          ></v-progress-linear>
        </v-layout>
      </v-container>
    </v-content> -->

    <v-footer app color="transparent">
      <v-layout align-center justify-center>
        <span class="text-center body-2"
          >&reg; Inteldatos 2021 -
          {{ this.$Amplify.I18n.get("All rights reserved") }}</span
        >
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "InforSuscripction",
  components: {},
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setMisCpcs", "setEmpresa", "setSuscripcion"]),
    signOut: function() {
      this.$Amplify.Auth.signOut()
        .then(() => {
          this.logger.info("signout success");
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch((e) => this.setError(e));
    },
    continuar: async function() {
      if (this.empresa.activo) {
        this.$router.push("/dashboard/inicio");
      } else {
        this.signOut();
      }
    },
  },
  computed: {
    ...mapGetters(["empresa"]),
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);

    /*  setTimeout(() => {
      this.loading = false;
      this.$router.push("/");
    }, 5000); */
  },
};
</script>
